import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { callMsGraphApisPost } from "../../utils/msalApiCalls";

import { RootState } from "../index";

interface UserData {
  displayName: string;
  userType: string;
  department: string;
  mail: string;
  jobTitle: string;
}

interface CtUserList {
  isLoading: boolean;
  data: {
    value: UserData[];
  };
  error: string | null;
}

const initialState: CtUserList = {
  isLoading: false,
  data: { value: [] },
  error: null,
};

export interface ResponseError {
  message: string;
}

interface SearchParam {
  query: string;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const searchUsers = createAsyncThunk<any, SearchParam>(
  "CTDBProductApproverListSlice/searchUser",
  async (searchParam, thunkApi) => {
    const searchQuery =
      searchParam.query.trim().length > 3 ? searchParam.query.trim() : " ";
    if (searchQuery.length < 3) {
      return;
    }
    try {
      const userList = await callMsGraphApisPost(
        `/?$select=displayName,userType,department,mail,jobTitle&$filter=(startswith(displayName,%27${searchQuery}%27)%20or%20startswith(givenName,%27${searchQuery}%27)%20or%20startswith(mail,%27${searchQuery}%27)%20or%20startswith(userPrincipalName,%27${searchParam}%27))`,
        false
      );
      return userList;
    } catch (error) {
      console.log("🚀 ~ error:", error);
      return thunkApi.rejectWithValue({
        message: "Failed to get user list",
      });
    }
  }
);

const CTDBProductApproverListSlice = createSlice({
  name: "CTDBProductApproverListSlice",
  initialState,
  reducers: {
    resetSearchUsers: (state) => {
      state.isLoading = false;
      state.data = { value: [] };
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchUsers.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.data = { value: [] };
      })
      .addCase(
        searchUsers.fulfilled,
        (state, action: PayloadAction<{ value: UserData[] }>) => {
          state.isLoading = false;
          state.data = action.payload;
          state.error = null;
        }
      )
      .addCase(searchUsers.rejected, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.data = { value: [] };
        state.error = action.payload;
      });
  },
});

export const selectUserList = (state: RootState) => {
  return state.CTDBUserListSlice;
};

export const { resetSearchUsers } = CTDBProductApproverListSlice.actions;
export default CTDBProductApproverListSlice.reducer;
